<script lang="ts">
  import { page } from "$app/state"
  import { goto } from "$app/navigation"
  import httpClient, { ErrorConnection } from "$lib/axios-client"
  import { ErrorActionPage } from "$lib/components/page"
  import LoadingVoidPage from "$lib/components/page/loading-void-page.svelte"
  import type { _response } from "$lib/data/type/_response"
  import type { User } from "$lib/data/type/user"
  import { appStore } from "$lib/stores/app-store.svelte"
  import { deviceStore } from "$lib/stores/device-store.svelte"
  import { createQuery } from "@tanstack/svelte-query"
  import { onMount } from "svelte"

  const { children } = $props()

  const device = $derived(deviceStore.device)
  const deviceToken = $derived(deviceStore.deviceToken)
  const accountId = $derived(page.url.pathname.split("/").filter(Boolean)[0] ?? "")
  const employeeId = $derived(appStore.user?.employee?.id ?? accountId)

  const app = createQuery(() => ({
    queryKey: ["_app", employeeId],
    queryFn: async () => {

      const response = await httpClient.post<_response<User>>("/api/auth/data", {
        device_id: device.device_id,
        device_name: device.device_name,
        fcm_token: deviceToken.fcm,
        timestamp: Date.now(),
        employee_id: employeeId,
      })
      const responseData = response.data.result

      if (!responseData) {
        appStore.userLogout()
        return ""
      }

      appStore.userUpdate(responseData)

      return ""
    },
  }))

  onMount(() => {

    const handleRedirect = (event: CustomEvent) => {
      goto(event.detail.target, { replaceState: true })
    }

    const handleLogout = () => {
      window.location.reload()
    }

    window.addEventListener("redirect", handleRedirect as EventListener)
    window.addEventListener("auth-logout", handleLogout)
    return () => {
      window.removeEventListener("redirect", handleRedirect as EventListener)
      window.removeEventListener("auth-logout", handleLogout)
    }
  })

</script>

{#if app.isFetching}
  <LoadingVoidPage/>
{:else if app.isError && app.error instanceof ErrorConnection}
  <ErrorActionPage
    message="Pastikan jaringan anda stabil untuk terhubung ke internet / perangkat utama"
    useActionReload={true}
  />
{:else if app.isError}
  <ErrorActionPage
    message="Halaman gagal dimuat, Silakan coba lagi."
    useActionReload={true}
  />
{:else}
  {@render children()}
{/if}
